import {getTabSelecoes} from "@/api/geral/helps";

export const state = {
    tab_grupo_108: [],
}

export const mutations = {
    SET_TAB_GRUPO_108: (state, valor) => {
        state.tab_grupo_108 = valor
    },
}

export const getters = {
    tabGrupo108(state) {
        return state.tab_grupo_108;
    },
}

export const actions = {
    // This is automatically run in `src/state/store.js` when the app
    // starts, along with any other actions named `init` in other modules.
    // eslint-disable-next-line no-unused-vars
    /*
    init({state, dispatch}) {
        dispatch('validate')
    },*/

    tabGrupo108({commit}) {
        return new Promise((resolve, reject) => {
            getTabSelecoes(999).then(response => {
                const {status, dados} = response
                console.log(dados)
                if (status) {
                    commit('SET_TAB_GRUPO_108', dados);
                    resolve(true)
                } else {
                    reject(false)
                }
            }).catch(error => {
                reject(error)
            })
        })
    },
}
